var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video',{staticClass:"video",attrs:{"src":_vm.payload.videoUrl,"poster":_vm.payload.thumbUrl,"controls":""},on:{"error":_vm.videoError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }